var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 27.3332C6.63622 27.3332 0.666687 21.3636 0.666687 13.9998C0.666687 6.63604 6.63622 0.666504 14 0.666504C21.3638 0.666504 27.3334 6.63604 27.3334 13.9998C27.3334 21.3636 21.3638 27.3332 14 27.3332ZM12.1626 9.21929C12.075 9.16088 11.972 9.12972 11.8667 9.12972C11.5722 9.12972 11.3334 9.36849 11.3334 9.66305V18.3366C11.3334 18.442 11.3646 18.5449 11.423 18.6325C11.5863 18.8776 11.9175 18.9438 12.1626 18.7804L18.6678 14.4436C18.7263 14.4045 18.7766 14.3542 18.8156 14.2957C18.9791 14.0506 18.9128 13.7194 18.6678 13.5561L12.1626 9.21929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/play_video.999987efc5b5f034f05912961831e14c.svg";
export { ForwardRef as ReactComponent };